import styled from 'styled-components';

import { CUST, CUST_ANIM, CUST_GRADIENTS } from '../../../../theme/customizer-tokens';

/**
 * Bordered, rounded map container (Figma "Frame 43248"): the translucent panel
 * plate + white hairline, r16, and `overflow: hidden` so a zoom-in to a country
 * is CLIPPED to the frame and never spills outside its bounds.
 */
export const Frame = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid ${CUST.mapFrameBorder};
  border-radius: 16px;
  background-image: ${CUST_GRADIENTS.panel};
  overflow: hidden;
`;

export const Svg = styled.svg`
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;

  path {
    fill: ${CUST.mapBase};
    stroke: ${CUST.mapStroke};
    stroke-width: 1;
    transition: fill 220ms ease;
  }

  path.selected {
    fill: ${CUST.mapSelected};
  }
`;

/** Inner group that pans/zooms to the selected country. CSS transform (not the
 *  source GSAP viewBox tween) so the move is a cheap, declarative transition. */
export const Zoom = styled.g<{ $transform: string }>`
  transform-box: view-box;
  transform-origin: 0 0;
  transform: ${({ $transform }) => $transform};
  transition: transform ${CUST_ANIM.MAP_ZOOM_MS}ms ${CUST_ANIM.MAP_EASE};
`;